var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"error-connection-text",attrs:{"tabindex":"0","aria-label":_vm.errorText}},[_vm._v("\n\t\t"+_vm._s(_vm.errorText)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }